import initVueApp from '@/tools/init-vue-app'
import store from '@/web/store'

import vHeader from '@/web/components/header.vue'

import HowToBuyLandingPage from '@/web/pages/landing_pages/how-to-buy.vue'

import '@/tools/icon-library'

import '@@/assets/stylesheets/shared/vendor/_criteo.scss'
import '@@/assets/stylesheets/shared/vendor/_fingerprint.scss'

import '@engines/stylesheets/ui/base/_normalize.scss'
import '@engines/stylesheets/ui/base/_generic.scss'

import '@engines/stylesheets/ui/trumps/_overrides.scss'

import '@engines/stylesheets/ui/objects/_container.scss'
import '@engines/stylesheets/ui/objects/_grid.scss'
import '@engines/stylesheets/ui/objects/_button.scss'
import '@engines/stylesheets/ui/objects/_icon.scss'
import '@engines/stylesheets/ui/objects/_logo.scss'
import '@engines/stylesheets/ui/objects/_input.scss'
import '@engines/stylesheets/ui/objects/_avatar.scss'
import '@engines/stylesheets/ui/objects/_separator.scss'
import '@engines/stylesheets/ui/objects/_count.scss'
import '@engines/stylesheets/ui/objects/_text.scss'

import '@@/assets/stylesheets/web/components/_header.scss'
import '@@/assets/stylesheets/web/components/_footer.scss'

const vueApps = [
  {
    name: 'header',
    components: { vHeader },
    store
  },
  {
    name: 'how-to-buy-landing-page',
    render: (h) => h(HowToBuyLandingPage),
    store
  }
]

vueApps.forEach(initVueApp)
